import { createActions, createReducer } from 'reduxsauce'

import ArquivosAtaRegistroPrecoService from '../../servicos/ArquivosContratoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaArquivosAtaRegistroPrecoInicio: [],
    buscaArquivosAtaRegistroPrecoSucesso: ['arquivosAtaRegistroPreco'],
    buscaArquivosAtaRegistroPrecoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaArquivosAtaRegistroPreco = filtro => {
    return dispatch => {
        dispatch(Creators.buscaArquivosAtaRegistroPrecoInicio())
        let serv = new ArquivosAtaRegistroPrecoService()
        return serv
            .consultarAnexosDetalhesAnexosAtaRegistroPreco(filtro)
            .then(response => dispatch(Creators.buscaArquivosAtaRegistroPrecoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaArquivosAtaRegistroPrecoErro(error)))
    }
}

const buscaArquivosAtaRegistroPrecoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaArquivosAtaRegistroPrecoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaArquivosAtaRegistroPrecoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.arquivosAtaRegistroPreco, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_ARQUIVOS_ATA_REGISTRO_PRECO_INICIO]: buscaArquivosAtaRegistroPrecoInicio,
    [Types.BUSCA_ARQUIVOS_ATA_REGISTRO_PRECO_ERRO]: buscaArquivosAtaRegistroPrecoErro,
    [Types.BUSCA_ARQUIVOS_ATA_REGISTRO_PRECO_SUCESSO]: buscaArquivosAtaRegistroPrecoSucesso,
})
